import React from 'react';
import PhantomEntryForm from './PhantomEntryForm';

function PhantomEntry3dForm(props) {
  return <PhantomEntryForm is3D {...props} />;
}

export default PhantomEntry3dForm;
